
import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {agent} from "./details/projectDetailActions";
import {errors, notices} from "./exceptions/errorActions";
import skuExceptionsReducer from "./exceptions/skuExceptionsSlice";
import disabledFieldsReducer from "./exceptions/disabledFieldsSlice";
import productDataReducer from './product/productDataSlice';
import productSelectionsReducer from './product/productSelectionsSlice';
import projectDetailsReducer from './details/projectDetailsSlice';
import configuratorStateReducer from './configuratorStateSlice';
import summaryReducer from './summarySlice';
import productsReducer from "./product/productsSlice";
import patternDetailsReducer from './details/patternDetailsSlice';
import patternSelectionsReducer from './product/patternSelectionsSlice';
import productElementsReducer from './product/productElementsSlice';
import patternSummary from './product/patterns/patternSummaryActions';
import {productApi} from "../configurator/services/productApi";
const configuratorApp = combineReducers({
    [productApi.reducerPath]: productApi.reducer,
    agent,
    configuratorStateReducer,
    disabledFieldsReducer,
    errors,
    notices,
    patternDetailsReducer,
    patternSelectionsReducer,
    patternSummary,
    projectDetailsReducer,
    productDataReducer,
    productElementsReducer,
    productsReducer,
    productSelectionsReducer,
    skuExceptionsReducer,
    summaryReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'RESET_APP') {
        state = undefined
    }
    return configuratorApp(state, action)
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(productApi.middleware)

});

export default store;
